export default __webpack_public_path__ + "static/platform-escalation-f3a481b2389e5e6fe451f2e6c5c4cf11.png";